import { render, staticRenderFns } from "./ChatSystemContent.vue?vue&type=template&id=4a78ae04"
import script from "./ChatSystemContent.vue?vue&type=script&lang=js"
export * from "./ChatSystemContent.vue?vue&type=script&lang=js"
import style0 from "./ChatSystemContent.vue?vue&type=style&index=0&id=4a78ae04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports